import { useDataChange, useDataValue } from 'Simple/Data.js'
import isEqual from 'lodash/isEqual.js'

export default function useListItemDataOnChange(props) {
  let change = useDataChange({
    context: 'selected',
    path: 'event.actionData',
    viewPath: props.viewPath,
  })

  let actions = useDataValue({
    context: 'selected',
    path: 'event.actionData',
    viewPath: props.viewPath,
  })

  return function onChange(rvalue) {
    let value = { ...rvalue, ...rvalue?.data }
    if (!isEqual(actions, value)) {
      change(value)
    }
  }
}
